<template>
  <form ref="form" @submit.prevent="submit">
    <div class="form-group">
      <div id="card-element" ref="cardInput">
        <!-- A Stripe Element will be inserted here. -->
      </div>
      <div v-if="errorMessage" class="invalid-feedback" style="display: block;">
        {{ errorMessage }}
      </div>
    </div>
    <b-button type="submit" variant="primary">
      {{ $t('general.add') }}
    </b-button>
    <b-button
      type="button"
      variant="light"
      class="ml-2"
      @click="$emit('cancelled')"
    >
      {{ $t('general.cancel') }}
    </b-button>
  </form>
</template>

<script>
import { ResourceFormMixin } from 'stylemix-vue-admin'
import { FormMixin } from 'stylemix-base'
import { mapState } from 'vuex'

import { loadStripe } from '../taxi-payments-js/Stripe'

export default {
  name: 'CardForm',

  mixins: [ResourceFormMixin, FormMixin],

  data() {
    return {
      user: {},
      StripeLoaded: false,
      stripe: {},
      card: {},
      errorMessage: null,
    }
  },

  computed: {
    ...mapState('admin-auth', ['accountMeta']),
  },

  mounted() {
    let promise = loadStripe(this.accountMeta.stripe_key)
    this.$uiBlocker(
      promise.then((stripe) => {
        this.StripeLoaded = true
        this.$nextTick(() => this.configureStripe(stripe))
      }),
      this.$refs.form
    )
  },

  methods: {
    configureStripe(stripe) {
      // Create an instance of Elements.
      const elements = stripe.elements()

      const style = {
        base: {
          fontSize: '14px',
          color: '#32325d',
          fontSmoothing: 'antialiased',
          '::placeholder': {
            color: '#ccc',
          },
        },
        invalid: {
          color: '#e5424d',
          ':focus': {
            color: '#303238',
          },
        },
      }

      // Create an instance of the card Element.
      const card = elements.create('card', {
        hidePostalCode: true,
        style: style,
      })

      // Add an instance of the card Element into the `card-element` <div>.
      card.mount(this.$refs.cardInput)
      this.card = card
      this.stripe = stripe

      card.addEventListener('change', event => {
        this.errorMessage = null
        if (event.error) {
          this.errorMessage = event.error.message
        }
      })
    },

    submit() {
      const self = this
      let res = this.stripe.createToken(this.card)
      this.$uiBlocker(res, this.$refs.form)
      this.errorMessage = null

      res.then(result => {
        if (result.error) {
          this.errorMessage = result.error.message
        } else {
          let promise = self.$http.post('cards', { token: result.token.id })

          self.$uiBlocker(promise, this.$refs.form)

          promise
            .then(result => {
              if (result.status === 200) {
                this.$toast.success(this.$t('account.add_card_success'))
              }

              this.$emit('saved', result.data.data)
            })
            .catch(({ response }) => {
              if (response) {
                this.errorMessage = response.data.message
              }
            })
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
/**
* The CSS shown here will not be introduced in the Quickstart guide, but shows
* how you can use CSS to style your Element's container.
*/
.form-group #card-element.StripeElement {
  box-sizing: border-box;
  height: 40px;

  padding: 10px 12px;

  border: 1px solid #dadada;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.form-group #card-element.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.form-group #card-element.StripeElement--invalid {
  border-color: #fa755a;
}

.form-group #card-element.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
